// extracted by mini-css-extract-plugin
export var border = "_k-7";
export var brand = "_k-s";
export var button = "_k-k";
export var center = "_k-9";
export var centered = "_k-5";
export var closeButton = "_k-b";
export var disabledWrapper = "_k-l";
export var error = "_k-o";
export var extraLarge = "_k-4";
export var extraSmall = "_k-1";
export var fill = "_k-h";
export var footer = "_k-g";
export var footerAction = "_k-i";
export var footerButtons = "_k-j";
export var header = "_k-6";
export var headerWithClose = "_k-c";
export var icon = "_k-n";
export var info = "_k-r";
export var inline = "_k-8";
export var large = "_k-3";
export var main = "_k-d";
export var modal = "_k-0";
export var neutral = "_k-t";
export var noPadding = "_k-f";
export var none = "_k-u";
export var scrollable = "_k-e";
export var small = "_k-2";
export var success = "_k-q";
export var tight = "_k-m";
export var titleIcon = "_k-a";
export var warn = "_k-p";